export default __webpack_public_path__ + "static/panel-anatomy-dark-481ce347a9c8753f780c11a827868973.png";